module.exports = [{
      plugin: require('/github/workspace/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/styles/typography"},
    },{
      plugin: require('/github/workspace/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-139165006-1"},
    },{
      plugin: require('/github/workspace/docs/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
